import React from "react";

const JobCompleted: React.FC = () => {
  const handleClose = () => {
    try {
      window.open('', '_self')?.close();
      window.close();
    } catch (e) {
      console.log('Could not close window', e);
    }
    // Fallback: redirect to a blank-ish page if window doesn't close
    setTimeout(() => {
      window.location.href = '/job-completed';
    }, 100);
  };

  return (
    <>
      <style>{`
        .job-completed-container {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #1D3340 0%, #2a4758 50%, #1D3340 100%);
          padding: 20px;
        }
        .completion-card {
          background: #fff;
          border-radius: 24px;
          padding: 48px 40px;
          text-align: center;
          max-width: 480px;
          width: 100%;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
          animation: slideUp 0.6s ease-out;
        }
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .success-icon-wrapper {
          width: 100px;
          height: 100px;
          margin: 0 auto 24px;
          background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          animation: scaleIn 0.5s ease-out 0.3s both;
        }
        @keyframes scaleIn {
          from {
            transform: scale(0);
          }
          to {
            transform: scale(1);
          }
        }
        .success-icon-wrapper svg {
          width: 50px;
          height: 50px;
        }
        .completion-title {
          font-size: 28px;
          font-weight: 700;
          color: #1D3340;
          margin-bottom: 12px;
        }
        .completion-message {
          font-size: 18px;
          color: #666;
          margin-bottom: 32px;
          line-height: 1.5;
        }
        .thank-you-text {
          font-size: 16px;
          color: #888;
          margin-bottom: 32px;
        }
        .btn-close-app {
          background: linear-gradient(135deg, #E07B00 0%, #ff9a3c 100%);
          color: #fff;
          border: none;
          padding: 16px 48px;
          border-radius: 12px;
          font-weight: 600;
          font-size: 18px;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 16px rgba(224, 123, 0, 0.4);
        }
        .btn-close-app:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(224, 123, 0, 0.5);
        }
        .company-logo {
          margin-top: 40px;
          opacity: 0.6;
        }
        @media (max-width: 576px) {
          .completion-card {
            padding: 32px 24px;
            border-radius: 16px;
          }
          .completion-title {
            font-size: 24px;
          }
          .completion-message {
            font-size: 16px;
          }
          .success-icon-wrapper {
            width: 80px;
            height: 80px;
          }
          .success-icon-wrapper svg {
            width: 40px;
            height: 40px;
          }
        }
      `}</style>
      
      <div className="job-completed-container">
        <div className="completion-card">
          <div className="success-icon-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>
          
          <h1 className="completion-title">Job Complete!</h1>
          
          <p className="completion-message">
            All deliveries for this job have been successfully completed.
          </p>
          
          <p className="thank-you-text">
            Thank you for your hard work today!
          </p>
          
          <button className="btn-close-app" onClick={handleClose}>
            Close
          </button>
          
          <div className="company-logo">
            <svg width="60" height="60" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="50" cy="50" r="45" stroke="#1D3340" strokeWidth="4" fill="none"/>
              <text x="50" y="58" textAnchor="middle" fill="#1D3340" fontSize="24" fontWeight="bold">DSS</text>
            </svg>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobCompleted;
